import className from 'classnames';
import React from 'react';
import './index.less';

interface SubHeaderProps {
  title: string;
  activeKey: string;
  setActiveKey: Function;
}

const tabs = [
  {
    name: '材质',
    key: 'material',
  },
  {
    name: '构件',
    key: 'element',
  },
];
const SubHeader: React.FC<SubHeaderProps> = (props) => {
  const { title, activeKey, setActiveKey } = props;

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  return (
    <div className="source-sub-header">
      <div className="source-header-title">{title}</div>
      <div className="source-sub-nav">
        {tabs.map((tab) => (
          <div
            onClick={() => onTabClick(tab.key)}
            className={className('source-header-item', {
              'source-header-item-active': activeKey === tab.key,
            })}
            key={tab.key}
          >
            {tab.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SubHeader);
